<template>
    <div ref="directoryRef" class="directory-container">
        <div class="directory-title center-text dinesafe-red-bg">Restaurant Directory</div>
       <DxDataGrid
            ref="gridRef"
            no-data-text="loading..."
            :show-column-headers="false"
            :data-source="allBusinessesData"
            :paging="{enabled: false}"
        >
          <DxColumn
              data-field="BusinessName"
              caption="Restaurant"
              data-type="text"              
              sort-order="asc"
          />
          <DxColumn
              data-field="Address"
              caption=""
              data-type="text"              
          />
          <DxColumn
              data-field="WebsiteURL"
              caption=""
              data-type="text"
              cell-template="website-button-template"
          />

          <DxColumn
              data-field="MenuURL"
              caption=""              
              cell-template="menu-button-template"
          />

          <template #website-button-template="{ data }">
            <div>
              <!-- Only show the button if the WebsiteURL has a value -->
              <DxButton v-if="data.data.WebsiteURL != null && data.data.WebsiteURL != ''" 
                ref="websiteButtonRef" 
                :width="120"
                type="normal"
                text="Website"
                styling-mode="contained"
                :visible="true"
                @click="btnUrlClick(data.data.WebsiteURL)"
                :element-attr="websiteButtonAttr"
              />
            </div>
          </template>

          <template #menu-button-template="{ data }">
            <div>
              <!-- Only show the button if the MenuURL has a value -->
              <DxButton v-if="data.data.MenuURL != null && data.data.MenuURL != ''" 
                ref="menuButtonRef" 
                :width="120"
                type="normal"
                text="Menu"
                styling-mode="contained"
                icon="food"
                :visible="true"
                @click="btnUrlClick(data.data.MenuURL)"
                :element-attr="menuButtonAttr"
              />
            </div>
          </template>

        </DxDataGrid>
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';

    export default {
        components: {
            DxButton,
            DxDataGrid, DxColumn,
        },
        props: {
            someProp: String,
        },
        data(){
            return{
                allBusinessesData: null,
                websiteButtonAttr: {
                    class: 'website-button'
                },
                menuButtonAttr: {
                    class: 'menu-button'
                }
            }
        },
        created(){
            this.getAllBusinessesData();
        },
        methods:{
            /*
                Get data for all active Business Accounts (Restaurants).  This will be used to populate a grid
                Stored Proc = pr_GetAllAccountsData
            */
            getAllBusinessesData(){
                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetAllBusinesses',
                {
                    //myParam: null,
                }
                ).then(function(data){         
                    //var responseData = JSON.parse(data.body);        
                        if(data.body != null && data.body != '')
                        {
                            var responseData = JSON.parse(data.body);  
                            this.allBusinessesData = responseData;
                        }
                });
            },
            /*

            */
            btnUrlClick(url){
                if(url != '' && url != null)
                {
                    window.location.href=url;
                }
            }
        }
    }
</script>

<style scoped>
  @import '../themes/contact-tracing.css';

  .website-button{
    background-color: #572D43;    
    color: white;  
  }

  .menu-button{
    background-color: #BB764C;
    color: white;
  }

</style>
